import React, { useState, useEffect } from 'react';
import './ApiKeyInput.css';

interface ApiKeyInputProps {
  onConnect: (apiKey: string, accountId: string) => void;
  isConnected: boolean;
  initialApiKey?: string;
  initialAccountId?: string;
}

const ApiKeyInput: React.FC<ApiKeyInputProps> = ({ onConnect, isConnected, initialApiKey, initialAccountId }) => {
  const [apiKey, setApiKey] = useState(initialApiKey || '');
  const [accountId, setAccountId] = useState(initialAccountId || '');

  // Update state when initial values change
  useEffect(() => {
    if (initialApiKey) setApiKey(initialApiKey);
    if (initialAccountId) setAccountId(initialAccountId);
  }, [initialApiKey, initialAccountId]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (apiKey.trim() && accountId.trim()) {
      onConnect(apiKey, accountId);
    }
  };

  return (
    <div className="api-key-container">
      <div className="glass-card">
        <div className="connection-status">
          <div className={`status-indicator ${isConnected ? 'connected' : 'disconnected'}`}></div>
          <span className="status-text">
            {isConnected ? 'Connected' : 'Not Connected'}
          </span>
        </div>
        
        <form onSubmit={handleSubmit} className="api-key-form">
  
          <div className="input-group">
            <label htmlFor="accountId">Account ID</label>
            <input
              type="text"
              id="accountId"
              value={accountId}
              onChange={(e) => setAccountId(e.target.value)}
              placeholder="Enter your account ID"
              className="glass-input"
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="apiKey">API Key</label>
            <input
              type="password"
              id="apiKey"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              placeholder="Enter your API key"
              className="glass-input"
              required
            />
          </div>
          
          <button type="submit" className="glass-button connect-button">
            <span className="button-text">Connect</span>
            <div className="button-glow"></div>
          </button>
        </form>
      </div>
    </div>
  );
};

export default ApiKeyInput;
